import React, { PropsWithChildren } from 'react';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { SavedReportsTranslation } from '../../constants';
import { GenericSavedReport } from '../../types-store';
import { SavedReportFormRenderer } from '../../types';

interface SavedReportDetailsProps<SavedReport extends GenericSavedReport> {
  savedReport: SavedReport;

  renderSavedReportForm: SavedReportFormRenderer<SavedReport>;

  onHideDetails: () => void;
  onDone: () => void;

  translation: SavedReportsTranslation;
}

export const SavedReportDetails = <SavedReport extends GenericSavedReport>({
  savedReport, renderSavedReportForm, onDone, onHideDetails, translation
}: PropsWithChildren<SavedReportDetailsProps<SavedReport>>) => {

  return <DialogExpander
    onClose={onHideDetails}
    onConfirm={onDone}
    textDone={translation.done}
    disabled={!savedReport?.code?.value}
    className="tile-details-view">
    {renderSavedReportForm(savedReport)}
  </DialogExpander>;
};
